import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import {
  AVAILABILITY_CONSTANTS,
  AVAILABILITY_STATES
} from "../../constants/AvailabilityConstants";
import ModalTemplate from "@//shared/components/ModalTemplate/ModalTemplate.vue";
import { AvailabilityService } from "../../services/AvailabilityService";
import { PreventKey } from "@/shared/mixins/mixins";
import { EventRange } from "../../models/EventRange.model";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import Snackbar from "@/shared/components/Snackbar/Snackbar";

Vue.use(Vuetify);
@Component({
  name: "UpdateEvent",
  components: { ModalTemplate }
})
export default class UpdateEvent extends PreventKey {
  @Inject() availabilityService!: AvailabilityService;
  @Prop() private showDialog?: boolean;
  @Prop() private eventData!: EventRange;

  TITLE_UPDATE_EVENT = AVAILABILITY_CONSTANTS.TEXTS.TITLE_UPDATE_EVENT;
  LOCK_EVENT = AVAILABILITY_CONSTANTS.TEXTS.LOCK_EVENT;
  UNLOCK_EVENT = AVAILABILITY_CONSTANTS.TEXTS.UNLOCK_EVENT;
  DELETE_EVENT = AVAILABILITY_CONSTANTS.TEXTS.DELETE_EVENT;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  AVAILABILITY_STATES = AVAILABILITY_STATES;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;

  isLocked = false;
  loadingData = false;

  showModalConfirmation = false;
  modalConfirmationTitle = AVAILABILITY_CONSTANTS.TEXTS.TITLE_DELETE_EVENT;
  modalConfirmationText = AVAILABILITY_CONSTANTS.TEXTS.TEXT_DELETE_EVENT;

  mounted() {
    this.setUpdateText();
  }

  @Watch("eventData")
  setUpdateText() {
    this.isLocked = this.eventData.locked > 0;
  }

  async updateEvent(status: string) {
    try {
      this.loadingData = true;
      const response = await this.availabilityService.updateAvailabilityEvent(
        this.eventData._key,
        status,
        this.eventData
      );
      if (response.code === Http.Conflict) Snackbar.popError(response.message);
      else Snackbar.popInfo(response.message);
      this.cancel();
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    this.loadingData = false;
  }

  async deleteEvent() {
    try {
      this.loadingData = true;
      const response = await this.availabilityService.deleteAvailabilityEvent(
        this.eventData._key,
        this.eventData.rangeEventsId
      );
      if (response.code === Http.Conflict) Snackbar.popError(response.message);
      else Snackbar.popInfo(response.message);
      this.cancel();
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    this.loadingData = false;
  }

  cancel() {
    this.$emit(AVAILABILITY_CONSTANTS.EVENTS.SAVE_MODAL_CANCEL);
  }

  async handleModalAccept() {
    this.handleModalCancel();
    this.deleteEvent();
  }

  handleModalCancel() {
    this.showModalConfirmation = false;
  }
}
